import script from "./payments-and-support.vue?vue&type=script&setup=true&lang=js"
export * from "./payments-and-support.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__